import { IKeyStringDict } from "@/types/GlobalTypes";

const ID: IKeyStringDict = {
	"language_code": "id",
	"txt_language": "Bahasa",
	"txt_info": "Info",
	"txt_userid": "Nama Akun",
	"txt_balance": "Saldo Chip",
	"txt_online_users": "Pemain Online",
	"txt_user": "Pemain",
	"txt_online": "Online",
	"txt_multitable": "MEJA GANDA",
	"txt_exit": "KELUAR",
	"txt_tap_fullscreen": "Klik di sini untuk layar penuh",
	"txt_lost_connection_server": "Koneksi ke server terputus, harap segarkan browser anda.",
	"txt_no_how_to_play": "Tidak ada cara bermain tersedia untuk permainan ini",
	"txt_no_data_available": "Tidak ada data",
	"txt_all_games": "SEMUA PERMAINAN",
	"txt_fast-tables_games": "FAST TABLE",
	"txt_favorites": "FAVORIT",
	"txt_categories": "CATEGORIES",
	"txt_dice_games": "DADU",
	"txt_ball_games": "BOLA",
	"txt_casino_games": "KASINO",
	"txt_other_games": "LAINNYA",
	"txt_game_name_m6": "24Dspin",
	"txt_game_name_m7": "Oglok",
	"txt_game_name_m8": "Dice 6",
	"txt_game_name_m10": "Head Tail",
	"txt_game_name_m11": "Red White",
	"txt_game_name_m13": "Billiards",
	"txt_game_name_m14": "Poker Dice",
	"txt_game_name_m16": "Gong Ball",
	"txt_game_name_m19": "Suwit",
	"txt_game_name_m20": "Monopoly",
	"txt_game_name_m21": "Monopoly World Cup",
	"txt_game_name_m22": "Baccarat",
	"txt_game_name_m23": "Dragon & Tiger",
	"txt_game_name_m24": "NiuNiu",
	"txt_game_name_m25": "FanTan",
	"txt_game_name_m27": "Shio Fights",
	"txt_game_name_m28": "IDN 4 Stand",
	"txt_game_name_m30": "5D",
	"txt_game_name_m32": "SamGong",
	"txt_game_name_m33": "Gong Ball Jitu",
	"txt_game_name_m34": "HILO",
	"txt_game_name_m35": "48D",
	"txt_game_name_m36": "36D",
	"txt_game_name_p6": "24D",
	"txt_game_name_p7": "Roulette",
	"txt_game_name_p9": "12D",
	"txt_game_name_p12": "Sicbo[Dice]",
	"txt_game_name_m26": "Race Ball",
	"txt_game_name_m29": "3D Shio",
	"txt_game_name_m31": "Sicbo Ball - Fast",
	"txt_game_name_p7b": "Roulette 2 - Fast Table",
	"txt_game_name_m17": "Toto Macau",
	"txt_game_name_m37": "Bingo Sicbo",
	"txt_game_name_m38": "Bingo Baccarat",
	"txt_game_name_m38b": "Bingo Baccarat 2",
	"txt_game_name_m39": "Duel Dice",
	"txt_game_name_m40": "Xoc Dia",
	"txt_game_name_m42": "Pinball",
	"txt_game_name_m50": "Toto Singapore",
	"txt_game_name_m51": "Toto Macau 5D",
	"txt_game_name_toto": "IDN Lotto",
	
	"txt_bet_closed": "TARUHAN DITUTUP",
	"txt_roadmap": "POLA",
	"txt_history": "RIWAYAT",
	"txt_statistics": "STATISTIK",
	"txt_statistics_first": "STATISTIK BOLA KE-1",
	"txt_show_all_roadmap": "Tunjukkan semua pola",
	"txt_show_all_history": "Tunjukkan semua riwayat",
	"txt_play_now": "MAIN",
	"txt_new_game_badge": "BARU",
	"txt_history_result": "Riwayat Hasil",
	"txt_history_win": "Riwayat Menang",
	"txt_how_to_play": "Cara Bermain",
	"txt_full_screen": "Layar Penuh",
	"txt_total_bet": "Taruhan Total",
	"txt_transaction": "Transaksi",
	"txt_news": "Berita",
	"txt_settings": "Pengaturan",
	"txt_promotions": "Promosi",
	"txt_new_game": "Permainan Baru",
	"txt_new_features": "Fitur Baru",
	"txt_bonus_history": "Riwayat Bonus",
	"txt_memo": "Memo",
	"txt_referral": "Referral",
	"txt_periode": "Periode",
	"txt_number": "Nomor",
	"txt_back": "Back",
	"txt_back_to_lobby_message": "Are you sure you want to go back to Lobby?",
	"txt_yes": "Yes",
	"txt_no": "No",
	"txt_transaction_history": "Riwayat Transaksi",
	"txt_result_history": "Riwayat Hasil",
	"txt_number_pagination": "NO.",
	"txt_date": "Tanggal",
	"txt_status": "Status",
	"txt_debit": "Debit",
	"txt_credit": "Kredit",
	"txt_win": "Menang",
	"txt_won": "Menang",
	"txt_lose": "Kalah",
	"txt_buy": "Beli",
	"txt_refund": "Refund",
	"txt_bet": "Taruhan",
	"txt_guess": "Tebak",
	"txt_prize": "Hadiah",
	"txt_discount": "Diskon",
	"txt_x_win": "X-Menang",
	"txt_correction": "Koreksi",
	"txt_total_win": "Total Menang",
	"txt_total": "Total",
	"txt_type": "Tipe",
	"txt_amount": "Jumlah",
	"txt_touch_to_close": "Sentuh di sini untuk menutup",
	"txt_all_odd": "All Odd",
	"txt_all_even": "All Even",
	"txt_all_low": "All Low",
	"txt_all_high": "All High",
	"txt_clear": "Clear",
	"txt_undo": "Undo",
	"txt_rebet": "Rebet",
	"txt_submit": "Submit",
	"txt_table_name": "Nama Meja",
	"txt_bet_limit": "Batas Bet",
	"txt_min_number": "Min. Nomor",
	"txt_max_number": "Maks. Nomor",
	"txt_min_50": "Min. 50-50",
	"txt_max_50": "Maks. 50-50",
	"txt_table_information": "Informasi Meja",
	"txt_toggle_streaming": "Nyala/Matikan Streaming",
	"txt_wait_next_round": "Tunggu ronde selanjutnya",
	"txt_place_bet": "Pasang taruhan",
	"txt_bet_close_in": "Taruhan segera ditutup",
	"txt_video_is_off_desktop_message": "Video is off\nGo to settings to turn on",
	"txt_video_is_off_mobile_message": "Video is off\nTap to turn on",
	"txt_loading_video": "Memuat video...",
	"txt_odd_even": "Ganjil-Genap",
	"txt_odd": "Ganjil",
	"txt_even": "Genap",
	"txt_small_big": "Kecil-Besar",
	"txt_small": "Kecil",
	"txt_big": "Besar",
	"txt_detail": "Rincian",
	"txt_red": "Merah",
	"txt_blue": "Biru",
	"txt_black": "Hitam",
	"txt_white": "Putih",
	"txt_head": "Kepala",
	"txt_tail": "Ekor",
	"txt_banker": "Banker",
	"txt_player": "Player",
	"txt_result": "Hasil",
	"txt_any_double": "Semua Double",
	"txt_any_triple": "Semua Tripel",
	"txt_triple": "Tripel",
	"txt_one": "Satu",
	"txt_two": "Dua",
	"txt_three": "Tiga",
	"txt_four": "Empat",
	"txt_five": "Lima",
	"txt_six": "Enam",
	"txt_seven": "Tujuh",
	"txt_eight": "Delapan",
	"txt_nine": "Sembilan",
	"txt_ten": "Sepuluh",
	"txt_balls_passed_line": "Bola Lewat Garis",
	"txt_balls": "bola",
	"txt_on_one_dice": "PADA SATU DADU",
	"txt_on_two_dice": "PADA DUA DADU",
	"txt_on_three_dice": "PADA TIGA DADU",
	"txt_shrimp": "Udang",
	"txt_chicken": "Ayam",
	"txt_jug": "Kendi",
	"txt_crab": "Kepiting",
	"txt_fish": "Ikan",
	"txt_2_pairs": "2 Pasang",
	"txt_3_of_a_kind": "3 of a Kind",
	"txt_inc_straight": "Inc. Straight",
	"txt_flush": "Flush",
	"txt_full_house": "Full House",
	"txt_straight": "Straight",
	"txt_4_of_a_kind": "4 of a Kind",
	"txt_inc_straight_flush": "Inc. Straight Flush",
	"txt_straight_flush": "Straight Flush",
	"txt_5_of_a_kind": "5 of a Kind",
	"txt_line": "Kolom",
	"txt_row": "Baris",
	"txt_1st_line": "Kolom 1",
	"txt_2nd_line": "Kolom 2",
	"txt_3rd_line": "Kolom 3",
	"txt_4th_line": "Kolom 4",
	"txt_5th_line": "Kolom 5",
	"txt_6th_line": "Kolom 6",
	"txt_7th_line": "Kolom 7",
	"txt_8th_line": "Kolom 8",
	"txt_9th_line": "Kolom 9",
	"txt_10th_line": "Kolom 10",
	"txt_1st_row": "Baris 1",
	"txt_2nd_row": "Baris 2",
	"txt_3rd_row": "Baris 3",
	"txt_4th_row": "Baris 4",
	"txt_2_to_1": "2 TO 1",
	"txt_1st_2nd_line": "Kolom 1 & 2",
	"txt_2nd_3rd_line": "Kolom 2 & 3",
	"txt_3rd_4th_line": "Kolom 3 & 4",
	"txt_4th_5th_line": "Kolom 4 & 5",
	"txt_5th_6th_line": "Kolom 5 & 6",
	"txt_1st_line_2nd_line": "Baris 1 & 2",
	"txt_3rd_line_4th_line": "Baris 3 & 4",
	"txt_1_to_18": "1-18",
	"txt_19_to_36": "19-36",
	"txt_left": "Kiri",
	"txt_right": "Kanan",
	"txt_key": "Hadiah",
	"txt_coin": "Koin",
	"txt_jackpot": "JP",
	"txt_pictures": "Gambar",
	"txt_square": "KOTAK",
	"txt_circle": "LINGKARAN",
	"txt_others": "LAINNYA",
	"txt_either_pair": "Salah Satu Pasangan",
	"txt_player_pair": "Pasangan Player",
	"txt_perfect_pair": "Pasangan Sempurna",
	"txt_banker_pair": "Pasangan Banker",
	"txt_tie": "Seri",
	"txt_tie_on": "Tie On",
	"txt_dice": "Dadu",
	"txt_shoe": "Set Kartu",
	"txt_round_id": "ID Putaran",
	"txt_new_shoe_message": "New Shoe in progress\nPlease wait",
	"txt_less_bet": "Less Bet",
	"txt_more_bet": "More Bet",
	"txt_sounds": "Suara",
	"txt_music": "Musik",
	"txt_auto_confirm_bet": "Otomatis kirim taruhan",
	"txt_auto_rebet": "Otomatis pasang kembali",
	"txt_video": "Video",
	"txt_enable_rotation": "Nyalakan Rotasi",
	"txt_batu": "Batu",
	"txt_gunting": "Gunting",
	"txt_kertas": "Kertas",
	"txt_jempol": "Jempol",
	"txt_telunjuk": "Telunjuk",
	"txt_kelingking": "Kelingking",
	"txt_rat": "tikus",
	"txt_ox": "kerbau",
	"txt_tiger": "harimau",
	"txt_rabbit": "kelinci",
	"txt_dragon": "naga",
	"txt_snake": "ular",
	"txt_horse": "kuda",
	"txt_goat": "kambing",
	"txt_monkey": "monyet",
	"txt_rooster": "ayam",
	"txt_dog": "anjing",
	"txt_pig": "babi",
	"txt_tickets": "TIKET",
	"txt_remove_unwanted_tickets": "Silakan hapus tiket yang tidak perlu sebelum mengirim.",
	"txt_submit_to_confirm_rebet": "Tekan tombol Submit untuk memastikan Rebet.",
	"txt_no_tickets": "Anda tidak punya tiket berjalan.",
	"txt_running_tickets": "TIKET BERJALAN",
	"txt_choose_bet_type": "Choose bet type to start.",
	"txt_place_bet_amount": "Please place your bet amount first.",
	"txt_add_tickets": "Add Tickets",
	"txt_choose_bet_type_message": "Please choose Bet Type to start.",
	"txt_remove_unwanted_ticket_message": "Please remove the unwanted tickets before submitting.\nClick Submit button to confirm rebet.",
	"txt_rebet_ticket_message": "You still have rebet tickets!\nTouch \"Show\" to see, then touch Submit to send your bets.",
	"txt_drawing_result": "Drawing Result",
	"txt_m29_first": "Kop",
	"txt_m29_middle": "Kepala",
	"txt_m29_last": "Ekor",
	"txt_3_pictures": "3 Pictures",
	"txt_any_pictures": "Any Pictures",
	"txt_either_3_picture": "Either 3 Picture",
	"txt_either_any_picture": "Either Any Picture",

	//Gong Ball Jitu
	"txt_gbj_result_message": "Untuk melihat hasil langsung untuk game GONG BALL JITU, silahkan merujuk ke sisi Papan Gong Ball (sisi kiri) pada live streaming.",

	"txt_popup_streaming_quality": "Anda dapat mengganti kualitas video HD disini",

	// new lang for history toto macau
	"txt_action": "Aksi",

	// bet panel m39
	"txt_m39_red": "Merah",
	"txt_m39_blue": "Biru",
	"txt_m39_tie": "Seri",
	"txt_m39_odd": "Ganjil",
	"txt_m39_even": "Genap",
	"txt_m39_low": "Kecil",
	"txt_m39_high": "Besar",
	"txt_m39_Odd/Even": "Ganjil/Genap", 
	"txt_m39_Odd/Odd": "Ganjil/Ganjil", 
	"txt_m39_Even/Odd": "Genap/Ganjil", 
	"txt_m39_Even/Even": "Genap/Genap",
	"txt_m39_Low/High": "Kecil/Besar", 
	"txt_m39_Low/Low": "Kecil/Kecil", 
	"txt_m39_High/Low": "Besar/Kecil", 
	"txt_m39_High/High": "Besar/Besar",

	// htp m17
	"txt_m17_out-number": "No. Keluar",
	"txt_m17_4D/3D/2D": "4D/3D/2D",
	"txt_m17_free-plug": "Color Bebas",
	"txt_m17_2D-free-plug": "Color Bebas 2D",
	"txt_m17_plug-dragon": "Colok Naga",
	"txt_m17_plug-it-in": "Colok Jitu",
	"txt_m17_middle-edge": "Tengah Tepi",
	"txt_m17_combination": "Kombinasi", 
	"txt_m17_base": "Dasar",
	"txt_m17_50-50": "50-50",
	"txt_m17_shio": "Shio",
	"txt_m17_cross": "Silang",
	"txt_m17_flaming-flower": "Kembang Kempis",

	// how to play
	"txt_htp_intro": "PENGENALAN",
	"txt_htp_rules": "PERATURAN",
	"txt_htp_placing-bet": "MEMASANG TARUHAN",
	"txt_htp_bet-desc": "DESKRIPSI TARUHAN & CONTOH",
    "txt_htp_payout": "PEMBAYARAN",
	"txt_htp_rank": "PERINGKAT",
	"txt_complete_information": "INFORMASI LENGKAP"
};

export default ID;